import { FC, useEffect, useState } from "react"

import styles from "./XTags.module.scss"
import {Radio} from "antd"
import React from "react"

export const XTag: FC<XTagProps> = ({
  children, value, selected = "", onSelect, onClick
}) => {
  return (
    <>
      <div className={selected == value ? styles.active : ""} onClick={(ev) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (value == "add") {
          return onClick()
        }
        onSelect(value)
      }}>{children}</div>
    </>
  )
}

type XTagsExtensions = {
  XTag: typeof XTag
}

type XTagsProps = {
  children: any
  selected: string
  theme?: string
  style?: any
  onSelect: (val: string) => void
}

type XTagProps = {
  children: any
  value: string
  selected?: string
  onSelect: (val: string) => void
  onClick: () => void
}

export const XTags: FC<XTagsProps> & XTagsExtensions = ({
  theme = "", style = {}, children, selected, onSelect
}) => {

  const [childs, setChilds] = useState([] as any[])

  const childrenWithProps: any = React.Children.map(children, (child: any) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { selected, onSelect: children.onSelect == undefined ? onSelect : children.onSelect } as any);
    }
    return child;
  })

  return (
    <>
      <div className={styles.manager_tagged + " " + styles[theme]} style={style}>
        {childrenWithProps}
      </div>
    </>
  )
}

XTags.XTag = XTag